import { createContext } from "react";

import type { ContentApi } from "./contentApi";

/** Injected API (tests); `null` = build the real one from the session. */
export const ContentApiContext = createContext<ContentApi | null>(null);
